/**
 * Gets the version string to display in the UI based on the environment
 * @returns Version string appropriate for the current environment
 */
export function getVersionString(): string {
  const mode = import.meta.env.MODE;
  const version = import.meta.env.VITE_VERSION;
  const buildTimestamp = import.meta.env.VITE_BUILD_TIMESTAMP;
  const environment = import.meta.env.VITE_ENVIRONMENT;

  // If version is provided, use it (production with GitHub release tag)
  if (version) {
    return version;
  }

  // If build timestamp is provided, prefix with environment (staging/testing deployment)
  if (buildTimestamp) {
    if (environment) {
      return `${environment}-${buildTimestamp}`;
    }
    return buildTimestamp;
  }

  // Development mode or no version info provided
  if (mode === 'development') {
    return 'development build';
  }

  // Fallback for production builds without version info
  return 'production build';
}
